import service from './index'

const RECORDER_UPLOAD_URL = 'https://recorder.liverunapp.com/api/recording/upload-mp3-file'
const UPLOAD_HISTORY_KEY = 'admin-data-operations-upload-history'

function normalizeSearch(search) {
  if (!search) {
    return ''
  }

  const matches = String(search).match(/\d+/g)
  return matches ? matches.map(Number).join(',') : String(search).trim()
}

function normalizeTargetIds(targetIds) {
  if (Array.isArray(targetIds)) {
    return targetIds.map(Number).filter((id) => !Number.isNaN(id))
  }

  if (!targetIds) {
    return []
  }

  const matches = String(targetIds).match(/\d+/g)
  return matches ? matches.map(Number) : []
}

function buildBulkPayload(bulkAction) {
  return {
    ...bulkAction,
    targetIds: normalizeTargetIds(bulkAction.targetIds),
  }
}

function getUploadHistory() {
  if (!window.localStorage) {
    return []
  }

  try {
    return JSON.parse(window.localStorage.getItem(UPLOAD_HISTORY_KEY) || '[]')
  } catch (error) {
    return []
  }
}

function setUploadHistory(history) {
  if (!window.localStorage) {
    return
  }

  window.localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(history || []))
}

export default {
  searchRaces(search, page = 0) {
    return service.http.get('races', {
      params: {
        page,
        search: normalizeSearch(search),
      },
    })
  },

  getSessionsOfToday() {
    return service.http.get('racers/sessions-of-today')
  },

  getSessionsOfDay(year, month, day) {
    return service.http.get(`racers/sessions-of-day/${year}/${month}/${day}`)
  },

  getRaceResultsPage(raceId, page = 0, size = 200, search = '') {
    return service.http.get(`races/results-page/${raceId}`, {
      params: {
        page,
        size,
        search: normalizeSearch(search),
      },
    })
  },

  getMedalBoard(raceId) {
    return service.http.get(`races/medal-board/${raceId}`)
  },

  getMedalBoardMap(raceId) {
    return service.http.get(`races/medal-board-map/${raceId}`)
  },

  getMedalsGivenInRace(raceId) {
    return service.http.get(`races/medal-board-list/${raceId}`)
  },

  addMedalBoard(medalBoard) {
    return service.http.post('medal-boards', medalBoard)
  },

  removeMedalBoard(medalBoardId) {
    return service.http.delete(`medal-boards/${medalBoardId}`)
  },

  performMedalBulk(raceId, bulkAction) {
    return service.http.post(`medal-boards/bulk-medals/${raceId}`, buildBulkPayload(bulkAction))
  },

  addRaceResult(raceId, raceResult) {
    return service.http.post(`runner-race-resumes/add-result/${raceId}`, {
      distance: raceResult.distance,
      runnerId: raceResult.runnerId,
      finishDate: raceResult.finishDate,
    })
  },

  updateRaceResult(raceResultId, raceResult) {
    return service.http.post(`runner-race-resumes/update-result/${raceResultId}`, {
      distance: raceResult.distance,
      runnerId: raceResult.runnerId,
      finishDate: raceResult.finishDate,
    })
  },

  removeRaceResult(raceResultId) {
    return service.http.delete(`runner-race-resumes/${raceResultId}`)
  },

  searchRunners(search, page = 0) {
    return service.http.get('runners', {
      params: {
        page,
        search: normalizeSearch(search),
      },
    })
  },

  getRunner(runnerId) {
    return service.http.get(`runners/${runnerId}`)
  },

  getRunnerAnalytics(runnerId) {
    return service.http.get(`runners/analytics/${runnerId}`)
  },

  updateRunnerTotalDistanceFromResults(runnerId) {
    return service.http.post(`runners/analytics/update-total-distance_perfomed-results/${runnerId}`)
  },

  resetRunnerPassword(userId, newPassword = 'liverun') {
    return service.http.post('users/update-user-password', {
      userId,
      newPassword,
      currentPassword: '',
    })
  },

  addPromoCodeToRunner(runnerId, promoCodeIdOrCode) {
    return service.http.put(`runners/add-promocode/${runnerId}/${promoCodeIdOrCode}`)
  },

  removePromoCodeFromRunner(runnerId, promoCodeId) {
    return service.http.delete(`runners/remove-promocode/${runnerId}/${promoCodeId}`)
  },

  performPromoCodeBulk(bulkAction) {
    return service.http.post('promo-codes/promo-code-bulk', buildBulkPayload(bulkAction))
  },

  uploadMp3File(fileModel, onProgress) {
    if (!fileModel || !fileModel.file) {
      return Promise.reject(new Error('File invalid.'))
    }

    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('docFile', fileModel.file)
      formData.append('name', fileModel.name)
      formData.append('extension', fileModel.extension)

      const xhr = new XMLHttpRequest()
      xhr.responseType = 'json'
      xhr.open('post', RECORDER_UPLOAD_URL, true)

      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable || !onProgress) {
          return
        }

        onProgress(Math.floor((event.loaded / event.total) * 100))
      }

      xhr.onerror = () => reject(new Error('Error uploading file.'))
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response)
          return
        }

        reject(new Error('Error uploading file.'))
      }

      xhr.send(formData)
    })
  },

  getUploadHistory,

  addUploadHistoryEntry(entry) {
    const history = getUploadHistory()
    history.unshift(entry)
    setUploadHistory(history)
    return history
  },

  clearUploadHistory() {
    setUploadHistory([])
    return []
  },
}

export { normalizeSearch, normalizeTargetIds, RECORDER_UPLOAD_URL, UPLOAD_HISTORY_KEY }



// WEBPACK FOOTER //
// ./src/services/adminDataOperations.js